import { FormErrorMessage } from "@msuite/picasso";
import { z } from "zod";

export const projectRequestWonFormSchema = z.object({
	contractSum: z
		.any()
		.transform((value) => {
			if (Number.isNaN(value)) return 0;
			return value;
		})
		.pipe(
			z
				.number()
				.min(1)
				.positive()
				.or(z.string().transform(Number).pipe(z.number().min(1).positive())),
		),
});

export type ProjectRequestWonFormType = z.infer<typeof projectRequestWonFormSchema>;
export const FormError = FormErrorMessage<ProjectRequestWonFormType>;
